<template>
  <div class="in-title">
    <div class="in-title-content">{{ title }}</div>
    <el-button v-if="action" @click="action">{{buttonText}}</el-button>
  </div>
</template>

<script>
export default {
  name: "in-title",
  props: {
    title: {
      type: String,
      default: ''
    },
    action: {
      type: Function
    },
    buttonText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less">
.in-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 30px;
  text-align: left;
  width: 100%;
  height: 65px;
  padding: 10px;
  background-color: #409EFF;

  .in-title-content{
    font-weight: 800;
    font-size: 40px;
    color: aliceblue;
  }
  .el-button{
    margin-left: 30px;
    font-size: 20px;
    font-weight: 600;
    border-radius: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/in-title.vue